import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getProducts } from 'app/entities/product/product.reducer';
import { createEntity, getEntity, reset, updateEntity } from './monthly-product-usage.reducer';

export const MonthlyProductUsageUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const products = useAppSelector(state => state.product.entities);
  const monthlyProductUsageEntity = useAppSelector(state => state.monthlyProductUsage.entity);
  const loading = useAppSelector(state => state.monthlyProductUsage.loading);
  const updating = useAppSelector(state => state.monthlyProductUsage.updating);
  const updateSuccess = useAppSelector(state => state.monthlyProductUsage.updateSuccess);

  const handleClose = () => {
    navigate('/monthly-product-usage');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProducts({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.averagePrice !== undefined && typeof values.averagePrice !== 'number') {
      values.averagePrice = Number(values.averagePrice);
    }
    values.from = convertDateTimeToServer(values.from);
    values.until = convertDateTimeToServer(values.until);
    if (values.monthlyUsage !== undefined && typeof values.monthlyUsage !== 'number') {
      values.monthlyUsage = Number(values.monthlyUsage);
    }

    const entity = {
      ...monthlyProductUsageEntity,
      ...values,
      product: products.find(it => it.id.toString() === values.product?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          from: displayDefaultDateTime(),
          until: displayDefaultDateTime(),
        }
      : {
          ...monthlyProductUsageEntity,
          from: convertDateTimeFromServer(monthlyProductUsageEntity.from),
          until: convertDateTimeFromServer(monthlyProductUsageEntity.until),
          product: monthlyProductUsageEntity?.product?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.monthlyProductUsage.home.createOrEditLabel"
            data-cy="MonthlyProductUsageCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.monthlyProductUsage.home.createOrEditLabel">
              Create or edit a MonthlyProductUsage
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="monthly-product-usage-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.monthlyProductUsage.averagePrice')}
                id="monthly-product-usage-averagePrice"
                name="averagePrice"
                data-cy="averagePrice"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.monthlyProductUsage.from')}
                id="monthly-product-usage-from"
                name="from"
                data-cy="from"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.monthlyProductUsage.until')}
                id="monthly-product-usage-until"
                name="until"
                data-cy="until"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.monthlyProductUsage.monthlyUsage')}
                id="monthly-product-usage-monthlyUsage"
                name="monthlyUsage"
                data-cy="monthlyUsage"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.monthlyProductUsage.beginStand')}
                id="monthly-product-usage-beginStand"
                name="beginStand"
                data-cy="beginStand"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.monthlyProductUsage.endStand')}
                id="monthly-product-usage-endStand"
                name="endStand"
                data-cy="endStand"
                type="date"
              />
              <ValidatedField
                id="monthly-product-usage-product"
                name="product"
                data-cy="product"
                label={translate('crawlerBackendApp.monthlyProductUsage.product')}
                type="select"
              >
                <option value="" key="0" />
                {products
                  ? products.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/monthly-product-usage"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MonthlyProductUsageUpdate;
